import { Box } from "@primer/react";
import { useState } from "react";
import QuanHeGiaDinhHocSinh from "./QuanHeGiaDinhHocSinh";
import AnhChiEmPage from "./anh-chi-em/AnhChiEmPage";
import TinhTrangHonNhanPHPage from "./TinhTrangHonNhanPhuHuynh";

interface HocSinh {
    id: number;
    ho_ten: string;
    ma_hs: string;
    ma_tn: string;
    ngay_sinh: string;
    dm_gioitinh_id: number;
    gioi_tinh: string;
    ten_he: string;
    ten_lop: string;
    trang_thai: string;
}

interface Props {
    hocSinh: HocSinh;
    canEdit?: boolean;
}

const QuanHeGiaDinhLayout: React.FC<Props> = ({ hocSinh, canEdit = true }) => {
    const [selectedTab, setSelectedTab] = useState<"parents" | "ace">("parents");

    return (
        <Box>
          
            <Box sx={{ display: "grid", gap: 3 }}>
                <QuanHeGiaDinhHocSinh hocSinh={hocSinh} canEdit={canEdit} />
                <AnhChiEmPage hocSinh={hocSinh} canEdit={canEdit} />
                <TinhTrangHonNhanPHPage ts_hocsinh_id={hocSinh.id} canEdit={canEdit} />
            </Box>
        </Box>
    );
};

export default QuanHeGiaDinhLayout;
